import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider, theme } from "antd";
import RequireAuth from "./RequireAuth";

import MainPage from "./components/MainPage";
import StatusDetails from "./components/StatusDetails";
import "./index.css";

const MainApp = () => (
  <ConfigProvider theme={{ algorithm: theme.darkAlgorithm }}>
    <Router>
      <Routes>
        <Route path="/:environment?" element={
          <RequireAuth>
            <MainPage />
          </RequireAuth>
        } />
        <Route
          path="/status-details/:date/:projectIdentifier/:domain"
          element={
            <RequireAuth>
              <StatusDetails />
            </RequireAuth>
          }
        />
      </Routes>
    </Router>
  </ConfigProvider>
);

export default MainApp;
